// ===================================================== RELATED HIGHLIGHTS
document.querySelectorAll('.co-product-highlights-frame').forEach(container => {
  const allTabs = container.querySelectorAll('.co-product-highlights-tab');
  const items = container.querySelectorAll('.co-product-highlights-item');
  let currentIndex = 0;
  const autoplayEnabled = true; // Changed to true to demonstrate the feature
  const autoplayDelay = 3000;
  const pauseOnInteractionDelay = 3000; // Resume autoplay after 5 seconds of no interaction
  let autoplayInterval;
  let pauseTimeout;
  let isPaused = false;
  const tabGroups = {};
  
  // Group tabs by their corresponding item index
  allTabs.forEach((tab, index) => {
      const groupIndex = index % items.length;
      tab.dataset.tab = groupIndex;
      if (!tabGroups[groupIndex]) tabGroups[groupIndex] = [];
      tabGroups[groupIndex].push(tab);
  });
  
  const activateTab = (index) => {
      // Activate corresponding tabs
      Object.entries(tabGroups).forEach(([tabIndex, buttons]) => {
          const isActive = parseInt(tabIndex) === index;
          buttons.forEach(tab => {
              tab.classList.toggle('active', isActive);
              tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
      });
      
      // Activate corresponding items
      items.forEach((item, i) => {
          item.classList.toggle('active', i === index);
      });
      
      currentIndex = index;
  };
  
  const startAutoplay = () => {
      if (!autoplayEnabled || isPaused) return;
      clearInterval(autoplayInterval);
      autoplayInterval = setInterval(() => {
          const nextIndex = (currentIndex + 1) % items.length;
          activateTab(nextIndex);
      }, autoplayDelay);
  };
  
  const stopAutoplay = () => clearInterval(autoplayInterval);
  
  const pauseAutoplay = () => {
      if (!autoplayEnabled) return;
      isPaused = true;
      stopAutoplay();
      
      // Clear any existing pause timeout
      clearTimeout(pauseTimeout);
      
      // Set a new timeout to resume autoplay after no interaction
      pauseTimeout = setTimeout(() => {
          isPaused = false;
          startAutoplay();
      }, pauseOnInteractionDelay);
  };
  
  const resumeAutoplay = () => {
      if (!autoplayEnabled) return;
      clearTimeout(pauseTimeout);
      isPaused = false;
      startAutoplay();
  };
  
  // Add event listeners to tabs
  allTabs.forEach(tab => {
      const tabIndex = parseInt(tab.dataset.tab, 10);
      tab.setAttribute('role', 'button');
      tab.setAttribute('tabindex', '0');
      tab.setAttribute('aria-selected', 'false');
      
      tab.addEventListener('click', () => {
          activateTab(tabIndex);
          pauseAutoplay();
      });
      
      tab.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              activateTab(tabIndex);
              pauseAutoplay();
          }
      });
      
      // Pause on hover/focus
      tab.addEventListener('mouseenter', pauseAutoplay);
      tab.addEventListener('focus', pauseAutoplay);
  });
  
  // Also pause when hovering over the entire container
  container.addEventListener('mouseenter', pauseAutoplay);
  container.addEventListener('mouseleave', () => {
      // Only resume if not already paused by interaction
      if (!isPaused) return;
      clearTimeout(pauseTimeout);
      pauseTimeout = setTimeout(() => {
          isPaused = false;
          startAutoplay();
      }, pauseOnInteractionDelay);
  });
  
  // Initialize
  activateTab(0);
  startAutoplay();
});


// ===================================================== ACCORDION
class Accordion {
    constructor(element, options = {}) {
        this.accordion = element;
        this.options = {
            allowMultiple: element.dataset.allowMultiple === 'true' || options.allowMultiple || false,
            initialOpen: element.dataset.initialOpen || options.initialOpen || null,
            openAll: element.dataset.openAll === 'true' || options.openAll || false,
            animationDuration: options.animationDuration || 300,
            ...options
        };
        
        this.headers = this.accordion.querySelectorAll('[data-accordion-header]');
        this.contents = this.accordion.querySelectorAll('[data-accordion-content]');
        
        this.init();
    }
    
    init() {
        // Add initialized class to the accordion container
        this.accordion.classList.add('accordion-initialized');
        
        this.headers.forEach((header, index) => {
            // Set up accessibility attributes
            header.setAttribute('aria-expanded', 'false');
            header.setAttribute('aria-controls', `accordion-content-${index}`);
            header.id = `accordion-header-${index}`;
            
            const content = this.contents[index];
            content.setAttribute('aria-labelledby', `accordion-header-${index}`);
            content.id = `accordion-content-${index}`;
            content.setAttribute('role', 'region');
            
            // Add click event
            header.addEventListener('click', () => this.togglePanel(index));
            
            // Add keyboard support
            header.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.togglePanel(index);
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.focusNextHeader(index);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.focusPreviousHeader(index);
                }
            });
        });
        
        // Open initial panel if specified
        if (this.options.initialOpen !== null) {
            const initialIndex = parseInt(this.options.initialOpen);
            if (initialIndex >= 0 && initialIndex < this.headers.length) {
                this.openPanel(initialIndex);
            }
        }
        
        // Open all panels by default if specified
        if (this.options.openAll) {
            this.openAllPanels();
        }
        
        // Add delayed class after 0.5 seconds
        setTimeout(() => {
            this.accordion.classList.add('accordion-initialized-after');
        }, 500);
    }
    
    togglePanel(index) {
        const header = this.headers[index];
        const content = this.contents[index];
        const isOpen = header.classList.contains('active');
        
        if (isOpen) {
            this.closePanel(index);
        } else {
            if (!this.options.allowMultiple) {
                this.closeAllPanels();
            }
            this.openPanel(index);
        }
    }
    
    openPanel(index) {
        const header = this.headers[index];
        const content = this.contents[index];
        
        header.classList.add('active');
        header.setAttribute('aria-expanded', 'true');
        content.classList.add('active');
        
        // Set max-height for smooth animation
        content.style.maxHeight = content.scrollHeight + 'px';
    }
    
    closePanel(index) {
        const header = this.headers[index];
        const content = this.contents[index];
        
        header.classList.remove('active');
        header.setAttribute('aria-expanded', 'false');
        content.classList.remove('active');
        content.style.maxHeight = '0px';
    }
    
    closeAllPanels() {
        this.headers.forEach((_, index) => {
            this.closePanel(index);
        });
    }
    
    openAllPanels() {
        this.headers.forEach((_, index) => {
            this.openPanel(index);
        });
    }
    
    focusNextHeader(currentIndex) {
        const nextIndex = (currentIndex + 1) % this.headers.length;
        this.headers[nextIndex].focus();
    }
    
    focusPreviousHeader(currentIndex) {
        const prevIndex = currentIndex === 0 ? this.headers.length - 1 : currentIndex - 1;
        this.headers[prevIndex].focus();
    }
}

// Auto-initialize all accordions on page load
document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('[data-accordion]');
    accordions.forEach(accordion => {
        new Accordion(accordion);
    });
});

// Manual initialization function
function initAccordion(selector, options = {}) {
    const element = document.querySelector(selector);
    if (element) {
        return new Accordion(element, options);
    }
}
// ===================================================== RELATED PRODUCTS
document.querySelectorAll('.co-p-related').forEach((collection) => {
  const slider = collection.querySelector('.co-p-related-swiper');
  const scrollbar = collection.querySelector('.swiper-scrollbar');
  const prevButton = collection.querySelector('.swiper-button-prev');
  const nextButton = collection.querySelector('.swiper-button-next');
  const swiper = new Swiper(slider, {
    slidesPerView: 4,
    freeMode: true,
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton
    },
    scrollbar: {
      el: scrollbar,
      draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        spaceBetween: 10,
      },
      479: {
        slidesPerView: 2,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        spaceBetween: "1%",
      },
      990: {
        slidesPerView: 4,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        spaceBetween: "1%",
      },
    },
  });
  function getSlidesToMove() {
    return window.innerWidth < 768 ? 1 : 3;
  }
  nextButton.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    swiper.slideTo(swiper.activeIndex + getSlidesToMove());
  });
  prevButton.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    swiper.slideTo(swiper.activeIndex - getSlidesToMove());
  });
});